import { render } from "./Watch.vue?vue&type=template&id=493e027e&scoped=true"
import script from "./Watch.vue?vue&type=script&lang=js"
export * from "./Watch.vue?vue&type=script&lang=js"

import "./Watch.vue?vue&type=style&index=0&id=493e027e&lang=scss&scoped=true"

import exportComponent from "/vercel/path3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-493e027e"]])

export default __exports__